import { graphql, useStaticQuery } from "gatsby";

const useNavigationData = () => {
  const data = useStaticQuery(graphql`
    {
      primaryNavigation: kontentItemNavigationItem(system: {codename: {eq: "primary_navigation"}}) {
        id
        elements {
          elements {
            value {
              id
              preferred_language
              ... on kontent_item_navigation_item {
                id,
                elements {
                  title {
                    value
                  }
                  url_slug {
                    value
                  }
                  external_url {
                    value
                  }
                  elements {
                    value {
                      ... on kontent_item_navigation_item {
                        id
                        elements {
                          title {
                            value
                          }
                          url_slug {
                            value
                          }
                          external_url {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      secondaryNavigation: kontentItemNavigationItem(system: {codename: {eq: "secondary_navigation"}}) {
        id
        elements {
          elements {
            value {
              id
              preferred_language
              ... on kontent_item_navigation_item {
                id,
                elements {
                  title {
                    value
                  }
                  url_slug {
                    value
                  }
                  external_url {
                    value
                  }
                  icon {
                    value {
                      codename
                    }
                  }
                }
              }
            }
          }
        }
      }
      infoNavigation: kontentItemNavigationItem(system: {codename: {eq: "info_navigation"}}) {
        id
        elements {
          elements {
            value {
              id
              typename: __typename
              preferred_language
              ... on kontent_item_navigation_item {
                id
                elements {
                  title {
                    value
                  }
                  url_slug {
                    value
                  }
                  external_url {
                    value
                  }
                }
              }
            }
          }
        }
      }
      footerNavigation: kontentItemNavigationItem(system: {codename: {eq: "footer_navigation"}}) {
        id
        elements {
          elements {
            value {
              id
              typename: __typename
              preferred_language
              ... on kontent_item_navigation_section {
                id,
                elements {
                  title {
                    value
                  }
                  sub_items {
                    value {
                      ... on kontent_item_navigation_item {
                        id
                        elements {
                          title {
                            value
                          }
                          url_slug {
                            value
                          }
                          external_url {
                            value
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return data;
};

export default useNavigationData;
